import React, { useEffect, useState } from "react";
import { QueryParams } from "@ofqual/portal-core/core/types";
import { PersistentDrawer } from "./PersistentDrawer";
import ReactMarkdown from "react-markdown";
import { useIsMounted } from "@ofqual/portal-core/core/hooks";

export type GuidanceDrawerProps = {
  service: {
    get: (params?: QueryParams) => Promise<string>;
  };
  handleDrawerToggle: (isOpen: boolean) => void;
  open: boolean;
};

export const GuidanceDrawer: React.FC<GuidanceDrawerProps> = ({
  service,
  handleDrawerToggle,
  open,
}) => {
  const [guidance, setGuidance] = useState<string | null>(null);
  const isMounted = useIsMounted();

  useEffect(() => {
    (async () => {
      const result = await service.get();
      isMounted.current && setGuidance(result);
    })();
  }, [service, isMounted]);

  return (
    <PersistentDrawer
      text="Guidance"
      open={open}
      handleDrawerToggle={handleDrawerToggle}
    >
      {guidance ? <ReactMarkdown>{guidance}</ReactMarkdown> : null}
    </PersistentDrawer>
  );
};
